<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useMessageContext } from './provider.js';
import { displayEmoji } from 'dashboard/helper/telegramReactions';

// Reactions on a Telegram message: the client's come from Telegram, the
// operator's are set from the account there. Clicking one of the operator's
// own takes it back; clicking someone else's puts the same one from us.
const { contentAttributes, id, conversationId } = useMessageContext();
const store = useStore();
const { t } = useI18n();

const reactions = computed(() => contentAttributes.value?.reactions || []);
const isSaving = ref(false);

const toggle = async reaction => {
  if (isSaving.value) return;
  isSaving.value = true;
  try {
    await store.dispatch('reactToMessage', {
      conversationId: conversationId.value,
      messageId: id.value,
      emoji: reaction.mine ? '' : reaction.emoji,
    });
  } catch (error) {
    useAlert(error.response?.data?.error || t('CONVERSATION.REACTIONS.FAILED'));
  } finally {
    isSaving.value = false;
  }
};
</script>

<template>
  <div class="mt-1.5 flex flex-wrap gap-1">
    <button
      v-for="reaction in reactions"
      :key="reaction.emoji"
      type="button"
      class="flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-xs"
      :class="
        reaction.mine
          ? 'border-n-brand bg-n-brand/10 text-n-slate-12'
          : 'border-n-weak bg-n-alpha-1 text-n-slate-11'
      "
      :title="
        reaction.mine
          ? $t('CONVERSATION.REACTIONS.REMOVE')
          : $t('CONVERSATION.REACTIONS.ADD_SAME')
      "
      @click="toggle(reaction)"
    >
      <span>{{ displayEmoji(reaction.emoji) }}</span>
      <span v-if="reaction.count > 1">{{ reaction.count }}</span>
    </button>
  </div>
</template>
